module.exports = __webpack_public_path__ + "e78aa22d1e52744f4d6053f930a178a2.MP3";